import {allowNavigationAway} from "./navigationAway";

document.addEventListener('alpine:init', () => {

    // On what second show the session expiration modal
    const SHOW_MODAL_ON_LAST_SECONDS = 60;

    /**
     * Object to manage data contained within a session expiration modal.
     */
    Alpine.data('sessionExpireDialog', (lifetime) => ({

        /**
         * @var Number countdown's seconds left.
         */
        secondsLeft: 0,

        /**
         * @var Number session lifetime in minutes.
         */
        lifetime: lifetime,

        /**
         * @var Number|null countdown's timer ID.
         */
        timerId: null,

        /**
         * @var String|null URL of login page to redirect when countdown ends.
         */
        loginUrl: null,

        /**
         * @var bool true when Dialog popup is showing.
         */
        shown: false,

        /**
         * Init countdown and Livewire hooks.
         */
        init() {
            this.initializeCountdown();
            Livewire.hook('commit', ({commit, succeed}) => {
                succeed(() => {
                    // Equivalent of 'message.received'
                    if (!this.isPollingCommit(commit)) {
                        this.reinitializeCountdown();
                    }
                })
            })
        },

        /**
         * Check is the commit for polling.
         *
         * @param {Object} commit
         * @return {Boolean}
         */
        isPollingCommit(commit) {
            return commit.calls.length === 0;
        },

        /**
         * Get session lifetime in seconds.
         *
         * @return {number}
         */
        getLifetimeInSeconds() {
            return this.lifetime * 60;
        },

        /**
         * Initialize the data for countdown.
         */
        initializeCountdown() {
            if (this.lifetime) {
                this.startCountdown(this.getLifetimeInSeconds());
            }
        },

        /**
         * Re-initialize the countdown.
         */
        reinitializeCountdown() {
            this.deleteCountdown();
            this.initializeCountdown();
        },

        /**
         * Start the countdown.
         *
         * @param {Number} seconds
         */
        startCountdown(seconds) {
            this.secondsLeft = seconds;
            this.timerId = setInterval(() => {
                this.secondsLeft--;
                if (!this.isVisible() && this.secondsLeft <= SHOW_MODAL_ON_LAST_SECONDS) {
                    this.show();
                    return;
                }
                if (this.secondsLeft === 0) {
                    this.deleteCountdown();
                    allowNavigationAway();
                    this.goToLogin();
                }
            }, 1000);
        },

        /**
         * Delete current countdown.
         */
        deleteCountdown() {
            this.stopCountdown();
            this.secondsLeft = 0;
        },

        /**
         * Stop current countdown.
         */
        stopCountdown() {
            if (this.hasCountdown()) {
                clearInterval(this.timerId);
                this.timerId = null;
            }
        },

        /**
         * Check does exist running countdown.
         *
         * @return {boolean}
         */
        hasCountdown() {
            return Boolean(this.timerId);
        },

        /**
         * Show the confirmation dialog.
         *
         * @return void
         */
        show() {
            this.shown = true;
        },

        /**
         * Hide the dialog and extend the session.
         */
        hideAndExtendSession() {
            this.hide();
            this.stopCountdown();
            this.extendSession();
        },

        /**
         * Hide the confirmation dialog.
         *
         * @return void
         */
        hide() {
            this.shown = false;
        },

        /**
         * Check is session expiration shown.
         *
         * @return {boolean}
         */
        isVisible() {
            return this.shown;
        },

        /**
         * Allow navigation away in case of a change form and do log out.
         */
        allowNavigationAwayAndLogout() {
            allowNavigationAway();
            this.logout();
        },

        /**
         * Logout current user.
         */
        logout() {
            document.getElementById('logout-form').submit()
        },

        /**
         * Go to login page.
         */
        goToLogin() {
            window.location.href = this.loginUrl;
        },

        /**
         * Extend the session.
         */
        extendSession() {
            Livewire.dispatch('extend-session');
        },
    }));
});
